module.exports = __webpack_public_path__ + "img/Responsible Citizen.f8b4d6e1.svg";